import PromoPageV1 from './pages/pagev1/Pagev1';

function App() {
  return (
    <PromoPageV1 />
  );
}

export default App;
